// Pricing copied from Purpose's web pricing page (31 Oct 2026): annual $119.99 with a
// 7-day free trial and $0 due today, monthly with no trial behind "See all options".
// Both use the existing AI Coach prices: annual is the yearly price with a coupon that
// takes it to $119.99 (scripts/create-follow-through-coupon.mts), monthly is the
// existing $19.95 (Purpose charges $19.99).

export const FOLLOW_THROUGH_TRIAL_DAYS = 7;

export const FOLLOW_THROUGH_PRICES = {
  annual: 119.99,
  monthly: 19.95,
  /** Crossed-out "regular pricing" on the annual card: the live AI Coach yearly price. */
  annualRegular: 159.95,
} as const;

export const FOLLOW_THROUGH_PLAN_TYPES = ['annual', 'monthly'] as const;
export type FollowThroughPlanType = (typeof FOLLOW_THROUGH_PLAN_TYPES)[number];

function money(value: number): string {
  return `$${value.toFixed(2)}`;
}

const annualPerMonth = Math.round((FOLLOW_THROUGH_PRICES.annual / 12) * 100) / 100;
const monthlyPerYear = FOLLOW_THROUGH_PRICES.monthly * 12;

export const OFFER_COPY = {
  trialCta: 'Try for $0.00',
  trialTerms: `${FOLLOW_THROUGH_TRIAL_DAYS}-day annual trial · $0 due today · cancel before billing`,
  annual: {
    perMonth: money(annualPerMonth),
    billed: `Billed annually at ${money(FOLLOW_THROUGH_PRICES.annual)}/year after your ${FOLLOW_THROUGH_TRIAL_DAYS}-day trial`,
    discount: `${Math.round((1 - FOLLOW_THROUGH_PRICES.annual / monthlyPerYear) * 100)}% OFF · BEST VALUE`,
    savings: `Save ${money(monthlyPerYear - FOLLOW_THROUGH_PRICES.annual)}/year vs monthly`,
    regular: `${money(FOLLOW_THROUGH_PRICES.annualRegular)}/year`,
  },
  monthly: {
    price: money(FOLLOW_THROUGH_PRICES.monthly),
    perYear: `That's ${money(monthlyPerYear)}/year`,
    charged: `Charged ${money(FOLLOW_THROUGH_PRICES.monthly)}/month · no trial`,
    cta: 'Start Monthly',
    terms: 'Start instantly · 30-day money-back guarantee',
  },
} as const;

export const MEMBERSHIP_BENEFITS = [
  { title: 'Unlimited 1-on-1 coaching', text: 'Talk through anything, anytime. Your coach is always one message away.' },
  { title: 'Memory that learns who you are', text: 'Conversations build on each other. Never start over.' },
  { title: 'Personalized goal tracking', text: 'Goals shaped around your starting point, not a generic template.' },
  { title: 'Daily reflections & journaling', text: 'Guided prompts that turn five minutes into real progress.' },
  { title: 'Habit-building frameworks', text: "LifeHack's Full Life Framework, applied to the challenges you actually have." },
  { title: 'Always there, day or night', text: 'No appointments. Talk through what you need at 6am or 2am.' },
] as const;
